import { Button, IconButton } from "rsuite";

const Buttons = function (props) {
  const { buttons } = props;

  return buttons?.map((button, key) => {
    let Elm = Button;

    if (button.custom_classes.includes("is-desktop")) {
      return;
    }

    switch (button.type) {
      case "icon_button":
        Elm = IconButton;
        break;
    }

    let styles = button.styles;

    if (
      styles &&
      styles.backgroundImage &&
      !styles.backgroundImage.includes("url")
    ) {
      styles.backgroundImage = `url(${styles.backgroundImage})`;
    }

    return (
      <Elm
        key={key}
        style={styles}
        className={
          button.custom_classes ? button.custom_classes.join(" ") : null
        }
        onClick={(e) => onClick(button)}
        startIcon={
          button.icon && button.icon.position === "start"
            ? getIcon(button.icon)
            : null
        }
        endIcon={
          button.icon && button.icon.position === "end"
            ? getIcon(button.icon)
            : null
        }
        icon={
          button.icon && button.icon.position === "center"
            ? getIcon(button.icon)
            : null
        }
        circle={button.attributes && button.attributes.circle}
      >
        {button.title ? button.title : ""}
        {button.image && button.image.original ? (
          <img
            src={button.image.original}
            style={button.image.styles ? button.image.styles : {}}
          />
        ) : (
          ""
        )}
      </Elm>
    );
  });

  function getIcon(icon) {
    if (icon.type === "image") {
      return <img src={icon.value} />;
    }
  }

  function onClick(button) {
    if (button.data) {
      if (button.data.mobile && window.innerWidth <= 768) {
        onClickAction(button, button.data.mobile);
      } else {
        if (button.data.desktop && window.innerWidth > 768) {
          onClickAction(button, button.data.desktop);
        } else if (button.data.type) {
          onClickAction(button, button.data);
        }
      }
    }

    /*  if (button.data) {
            if (button.data.mobile && window.innerWidth <= 768) {
                onClickAction(button, button.data.mobile);
            } else if (button.data.desktop && window.innerWidth > 768) {
                onClickAction(button, button.data.desktop);
            } else if (button.data.type) {
                onClickAction(button, button.data);
            }
        }*/
  }

  function onClickAction(button, data) {
    switch (data.type) {
      case "intend":
        if (data.value) {
          window.location.href = data.value;
        }
        break;
    }
  }
};

export default Buttons;
